import { Injectable } from "@angular/core";

import { ModalService, SimpleModalOptions } from "@healthcatalyst/cashmere";
import { ComponentCanDeactivate } from "./component-can-deactivate";

@Injectable()
export class CanDeactivateGuard  {
    constructor(private modalService: ModalService) {}

    canDeactivate(component: ComponentCanDeactivate) {
        if (!component.canDeactivate()) {
            const options: SimpleModalOptions = {
                messageHTML: '<p>You have unsaved changes on this form. If you leave without pressing the "Save" button, you\'ll lose your changes.</p>',
                headerText: 'Are you sure you want to leave?',
                confirmButtonText: 'Leave without saving',
                icon: ''
            };
            return this.modalService.confirmDestructive(options);
        }
        return true;
    }
}